import type { MorphSelectOption } from '@/components/ui/MorphSelect'
import type { Locale } from '@/types'

export const LANGUAGE_OPTIONS: MorphSelectOption<Locale>[] = [
  {
    value: 'pt-BR',
    label: 'Português',
    icon: <span aria-hidden="true" className="text-base leading-none">🇧🇷</span>,
  },
  {
    value: 'en-US',
    label: 'English',
    icon: <span aria-hidden="true" className="text-base leading-none">🇺🇸</span>,
  },
]
